export const MEGASIG_PARAMETERS = [
  { label: "OSPL90 Max Frequency (Hz)", key: "ospl90_maxValueFrequency_Hz" },
  { label: "OSPL90 Max Value (dB)", key: "ospl90_maxValue_dB" },
  { label: "HFA OSPL90 (dB)", key: "hfa_ospl90_dB" },
  { label: "FOG50 Max Frequency (Hz)", key: "fog50_maxValueFrequency_Hz" },
  { label: "FOG50 Max Value (dB)", key: "fog50_maxValue_dB" },
  { label: "HFA FOG50 (dB)", key: "hfa_fog50_dB" },
  { label: "Target (dB)", key: "target_dB" },
  { label: "Measured (dB)", key: "measured_dB" },
  { label: "EQ Input Noise (dB)", key: "eq_inputNoise_dB" },
  { label: "Response Limit (dB)", key: "responseLimit_dB" },
  { label: "F1 (Hz)", key: "f1_Hz" },
  { label: "F2 (Hz)", key: "f2_Hz" },
  { label: "THD 500Hz 70dB (%)", key: "thd_500Hz_70dB_percent" },
  { label: "THD 800Hz 70dB (%)", key: "thd_800Hz_70dB_percent" },
  { label: "THD 1600Hz 65dB (%)", key: "thd_1600Hz_65dB_percent" },
  { label: "Attack Time (ms)", key: "attackTime_ms" },
  { label: "Release Time (ms)", key: "releaseTime_ms" },
];

export const getOverallStatus = (status) => {
  if (!status || typeof status !== "object") return "FAIL";
  const values = Object.values(status).map((item) =>
    String(item || "").trim().toUpperCase(),
  );
  if (values.length === 0) return "FAIL";
  return values.every((item) => item === "PASS") ? "PASS" : "FAIL";
};
